import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "@/shared/lib/utils";

interface ProgressProps extends React.ComponentProps<typeof ProgressPrimitive.Root> {
  isProgressing?: boolean;
  disableAnimation?: boolean;
}

function Progress({
  className,
  value,
  isProgressing = false,
  disableAnimation = false,
  ...props
}: ProgressProps) {
  const progress = (value ?? 0) - 100;

  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      className={cn(
        "bg-primary/20 relative h-2 w-full overflow-hidden rounded-full",
        className,
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-primary h-full w-full flex-1 relative",
          !disableAnimation && "transition-all",
        )}
        style={{ transform: `translateX(${progress}%)` }}
      />
      {isProgressing && !disableAnimation && (
        <div className="absolute inset-0 bg-gradient-to-r from-transparent from-30% via-white/70 via-50% to-transparent to-70% animate-shimmer pointer-events-none" />
      )}
    </ProgressPrimitive.Root>
  );
}

export { Progress };
